import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import STATUS from '../../atoms/Status';

const Timeline = ({ currentStatus }) => (
  [
    <div key="timeline" className="timeline">
      <div className="captionedIcon">
        <Icon imgStyle="timeline--icon__mobile" {...currentStatus === STATUS.RECEIVED ? { icon: 'receivedActive' } : { icon: 'received' }} alt="Order Received" />
        <div className={`caption${currentStatus === STATUS.RECEIVED ? ' caption-active' : ''}`}>Order Received</div>
      </div>
      <div className="line" />
      <div className="captionedIcon">
        <Icon imgStyle="timeline--icon__mobile" {...currentStatus === STATUS.PICKED ? { icon: 'pickedActive', active: true } : { icon: 'picked' }} alt="Being Picked" />
        <div className={`caption${currentStatus === STATUS.PICKED ? ' caption-active' : ''}`}>Being Picked</div>
      </div>
      <div className="line" />
      <div className="captionedIcon">
        <Icon imgStyle="timeline--icon__mobile" {...currentStatus === STATUS.DISPATCHED ? { icon: 'dispatchedActive', active: true } : { icon: 'dispatched' }} alt="Awaiting Dispatch" />
        <div className={`caption${currentStatus === STATUS.DISPATCHED ? ' caption-active' : ''}`}>Awaiting Dispatch</div>
      </div>
      <div className="line" />
      <div className="captionedIcon">
        <Icon imgStyle="timeline--icon__mobile" {...currentStatus === STATUS.EN_ROUTE ? { icon: 'enrouteActive', active: true } : { icon: 'enroute' }} alt="In Transit" style={{ marginRight: '10px' }} />
        <div className={`caption${currentStatus === STATUS.EN_ROUTE ? ' caption-active' : ''}`}>In Transit</div>

      </div>
      <div className="line" />
      <div className="captionedIcon">
        <Icon imgStyle="timeline--icon__mobile" {...currentStatus === STATUS.DELIVERED ? { icon: 'deliveredActive', active: true } : { icon: 'delivered' }} alt="Delivered" />
        <div className={`caption${currentStatus === STATUS.DELIVERED ? ' caption-final' : ''}`}>Delivered</div>
      </div>
    </div>,
    <div key="status" className={`status${currentStatus === STATUS.DELIVERED ? ' status-final' : ''}`}>
      Your order
      {currentStatus === STATUS.RECEIVED && ' has been received'}
      {currentStatus === STATUS.PICKED && ' is being picked'}
      {currentStatus === STATUS.DISPATCHED && ' is awaiting dispatch'}
      {currentStatus === STATUS.EN_ROUTE && ' is out for delivery'}
      {currentStatus === STATUS.DELIVERED && ' has been delivered'}
    </div>,
  ]
);

Timeline.propTypes = {
  currentStatus: PropTypes.string.isRequired,
};

export default Timeline;



// WEBPACK FOOTER //
// src/components/molecules/Timeline/index.jsx